import { CashbackToggleType } from '../../../../../components-library/checkout/CashbackToggle';

export default {
  [CashbackToggleType.Default]: {
    balance: '{{value}}p ({{moneyValue}}) available',
    optional: 'Use or keep collecting points',
    states: {
      on: 'Yes',
      off: 'No',
    },
  },
  [CashbackToggleType.Points]: {
    title_one: 'You have {{count}} point',
    title_other: 'You have {{count}} points',
    use_points: 'Use <highlight>{{value}} points ({{moneyValue}})</highlight>',
    buttons: {
      enabled: 'Undo',
      use: 'Activate',
    },
  },
  feedback: {
    min_spending_limit_not_reached: 'You need minimum {{value}} points to redeem',
    max_spending_limit: 'Maximum spent {{value}} points per order',
  },
  cashback: {
    enabled: 'Loyalty points applied successfully',
    cashback_removed: 'Loyalty points removed',
  },
};
